import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import { Button, FormHelperText } from '@mui/material'
import CustomInput from '../components/styled/CustomInput.styled'
import { saveOrUpdateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const ChangePasswordModal = ({
  handleChangePasswordModal,
  modalOpen = false,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [changePassword, setChangePassword] = React.useState({
    user_id: user?.id,
    old_password: '',
    password: '',
    password_confirmation: '',
  })

  const handleChange = (e) => {
    setChangePassword((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleChangePassword = async (e) => {
    e.preventDefault()
    let body = { ...changePassword }
    let result = await saveOrUpdateDataById('change-password', body)
    if (result?.success === true) {
      handleChangePasswordModal(false)
      Swal.fire({
        icon: 'success',
        title: 'Password updated successfully!',
        timer: 3000,
        confirmButtonColor: '#2597F6',
      })
    } else if (result?.success === false) {
      Swal.fire({
        icon: 'error',
        title: result?.message,
        timer: 3000,
        confirmButtonColor: '#2597F6',
      })
    }
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleChangePasswordModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="common-modal-width change-password">
          <form onSubmit={handleChangePassword}>
            <div>
              <h3 className="mb-4 fs-24">Change Password</h3>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  Current Password
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="••••••••••••"
                  id="old_password"
                  name="old_password"
                  fullWidth={true}
                  type="password"
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  New Password
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="••••••••••••"
                  id="password"
                  name="password"
                  fullWidth={true}
                  required
                  type="password"
                  onChange={handleChange}
                />
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-3"
                  margin="dense"
                >
                  Confirm New Password
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="••••••••••••"
                  id="password_confirmation"
                  fullWidth={true}
                  required
                  type="password"
                  onChange={handleChange}
                  name="password_confirmation"
                />
              </div>
              <Button
                fullWidth
                disableElevation
                id="btn-primary-no-shadow"
                className="pointer mt-5"
                type="submit"
              >
                Save
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  )
}

export default ChangePasswordModal
